import React, { createContext, useContext, useEffect, useState } from 'react';

const BackendStatusContext = createContext({ isDown: false });

export const useBackendStatus = () => useContext(BackendStatusContext);

export const BackendStatusProvider = ({ children }) => {
    const [isDown, setIsDown] = useState(false);

    useEffect(() => {
        const handler = () => setIsDown(true);
        window.addEventListener('backend:down', handler);
        return () => window.removeEventListener('backend:down', handler);
    }, []);

    return (
        <BackendStatusContext.Provider value={{ isDown }}>
            {children}
        </BackendStatusContext.Provider>
    );
};
